import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';

const WelcomeAgeVerify = ({ setScreenNumber }) => {
  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url("${getImageFromS3(
          'images/lm-double-splash/violet-background.png'
        )}")`
      }}
    >
      <p className={styles.title}>
        Час фотосесії!
        <br />
        Жартуємо
      </p>
      <img
        src="/images/traffic-lights.gif"
        alt="traffic-lights"
        className={styles.trafficLightsImage}
      />
      <div className={styles.descriptionContainer}>
        <img
          src={getImageFromS3('images/mpmb/face-capture.png')}
          alt="face-capture"
        />
        <p>
          Просто потрібна <b>коротка верифікація за допомогою камери</b>, щоб
          підтвердити, що тобі є 18.
        </p>
      </div>
      <div className={styles.infoContainer}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <rect width="16" height="16" rx="8" fill="#A26DF0" />
          <rect
            x="7.27344"
            y="6.54492"
            width="1.45455"
            height="5.09091"
            rx="0.727273"
            fill="#D9D9D9"
          />
          <rect
            x="7.27344"
            y="4.36328"
            width="1.45455"
            height="1.45455"
            rx="0.727273"
            fill="#D9D9D9"
          />
        </svg>
        <p>Усе конфіденційно: ми не зберігатимемо твою світлину</p>
      </div>
      <button onClick={() => setScreenNumber(14)}>Перейти до камери</button>
    </div>
  );
};

export default WelcomeAgeVerify;
